<template>
  <div>
    <div class="search">
      <el-input placeholder="请输入系列名称查询" style="width: 200px" v-model="name"></el-input>
      <el-select v-model="categoryId" placeholder="请选择分类" style="width: 150px; margin-left: 10px" clearable>
        <el-option
          v-for="item in categoryOptions"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <el-button type="info" plain style="margin-left: 10px" @click="load(1)">查询</el-button>
      <el-button type="warning" plain style="margin-left: 10px" @click="reset">重置</el-button>
    </div>

    <div class="operation">
      <el-button type="primary" plain @click="handleAdd">新增</el-button>
      <el-button type="danger" plain @click="delBatch">批量删除</el-button>
    </div>

    <div class="table">
      <el-table :data="tableData" stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column prop="id" label="序号" width="80" align="center" sortable></el-table-column>
        <el-table-column prop="name" label="系列名称"></el-table-column>
        <el-table-column prop="categoryName" label="所属分类" width="120"></el-table-column>
        <el-table-column label="封面图" width="180">
          <template v-slot="scope">
            <el-image v-if="scope.row.coverImage" style="width: 100px; height: 60px" :src="scope.row.coverImage" fit="cover" 
                     :preview-src-list="[scope.row.coverImage]"></el-image>
            <span v-else>暂无图片</span>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="描述" show-overflow-tooltip></el-table-column>
        <el-table-column prop="views" label="浏览量" width="80" align="center"></el-table-column>
        <el-table-column prop="publishDate" label="发布日期" width="120"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>

        <el-table-column label="操作" width="240" align="center">
          <template v-slot="scope">
            <el-button plain type="success" @click="handleManagePhotos(scope.row)" size="mini">管理照片</el-button>
            <el-button plain type="primary" @click="handleEdit(scope.row)" size="mini">编辑</el-button>
            <el-button plain type="danger" size="mini" @click="del(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[5, 10, 20]"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="total">
        </el-pagination>
      </div>
    </div>

    <el-dialog title="系列信息" :visible.sync="formVisible" width="40%" :close-on-click-modal="false" destroy-on-close>
      <el-form label-width="100px" style="padding-right: 50px" :model="form" :rules="rules" ref="formRef">
        <el-form-item prop="name" label="系列名称">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="categoryId" label="所属分类">
          <el-select v-model="form.categoryId" placeholder="请选择分类" style="width: 100%">
            <el-option
              v-for="item in categoryOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="coverImage" label="封面图">
          <el-upload
              class="avatar-uploader"
              :action="$baseUrl + '/files/upload'"
              :show-file-list="false"
              :on-success="handleAvatarSuccess">
            <img v-if="form.coverImage" :src="form.coverImage" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item prop="description" label="系列描述">
          <el-input type="textarea" :rows="3" v-model="form.description" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="publishDate" label="发布日期">
          <el-date-picker
            v-model="form.publishDate"
            type="date"
            placeholder="选择日期"
            style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="sortOrder" label="排序">
          <el-input-number v-model="form.sortOrder" :min="0" :max="1000"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "PhotoSeries",
  data() {
    return {
      tableData: [],  // 所有的数据
      pageNum: 1,   // 当前的页码
      pageSize: 10,  // 每页显示的个数
      total: 0,
      name: null,
      categoryId: null,
      categoryOptions: [],
      formVisible: false,
      form: {
        sortOrder: 0,
        views: 0,
        publishDate: new Date()
      },
      rules: {
        name: [
          {required: true, message: '请输入系列名称', trigger: 'blur'},
        ],
        categoryId: [
          {required: true, message: '请选择所属分类', trigger: 'change'},
        ],
        coverImage: [
          {required: true, message: '请上传封面图', trigger: 'blur'},
        ],
        sortOrder: [
          {required: true, message: '请输入排序', trigger: 'blur'},
        ]
      },
      ids: []
    }
  },
  created() {
    this.loadCategories()
    this.load(1)
  },
  methods: {
    loadCategories() {
      this.$request.get('/photo/category/list').then(res => {
        if (res.code === '200') {
          this.categoryOptions = res.data
        }
      })
    },
    handleAvatarSuccess(res) {
      if (res.code === '200') {
        this.form.coverImage = res.data
        this.$message.success('上传成功')
      } else {
        this.$message.error(res.msg)
      }
    },
    handleAdd() {
      this.loadCategories() // 确保加载最新的分类列表
      this.form = {
        name: '',
        coverImage: '',
        description: '',
        categoryId: null,
        type: '', // 初始为空，后续根据分类自动设置
        sortOrder: 0,
        views: 0,
        featured: 0,
        publishDate: new Date()
      }
      this.formVisible = true
    },
    handleEdit(row) {   // 编辑数据
      this.loadCategories() // 确保加载最新的分类列表
      this.form = JSON.parse(JSON.stringify(row))  // 给form对象赋值  注意要深拷贝数据
      this.formVisible = true   // 打开弹窗
    },
    handleManagePhotos(row) {
      // 跳转到照片管理页面，并传递系列ID
      this.$router.push({
        path: '/manager/photo',
        query: {
          seriesId: row.id,
          seriesName: row.name
        }
      })
    },
    save() {   // 保存按钮触发的逻辑  它会触发新增或者更新
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          // 确保categoryId是整数类型
          if (this.form.categoryId) {
            this.form.categoryId = parseInt(this.form.categoryId)
            
            // 确保type与分类关联
            if (!this.form.type || this.form.type === 'default') {
              const category = this.categoryOptions.find(item => item.id === this.form.categoryId);
              if (category) {
                this.form.type = category.code || 'default';
              }
            }
          }
          
          this.$request({
            url: this.form.id ? '/photo/series/admin/' + this.form.id : '/photo/series/admin',
            method: this.form.id ? 'PUT' : 'POST',
            data: this.form
          }).then(res => {
            if (res.code === '200') {  // 表示成功保存
              this.$message.success('保存成功')
              this.load(1)
              this.formVisible = false
            } else {
              this.$message.error(res.msg)  // 弹出错误的信息
            }
          })
        }
      })
    },
    del(id) {   // 单个删除
      this.$confirm('您确定删除吗？删除系列将同时删除该系列下的所有照片！', '确认删除', {type: "warning"}).then(response => {
        this.$request.delete('/photo/series/admin/' + id).then(res => {
          if (res.code === '200') {   // 表示操作成功
            this.$message.success('操作成功')
            this.load(1)
          } else {
            this.$message.error(res.msg)  // 弹出错误的信息
          }
        })
      }).catch(() => {
      })
    },
    handleSelectionChange(rows) {   // 当前选中的所有的行数据
      this.ids = rows.map(v => v.id)   //  [1,2]
    },
    delBatch() {   // 批量删除
      if (!this.ids.length) {
        this.$message.warning('请选择数据')
        return
      }
      this.$confirm('您确定批量删除这些数据吗？删除系列将同时删除该系列下的所有照片！', '确认删除', {type: "warning"}).then(response => {
        this.$request.delete('/photo/series/admin/batch', {data: this.ids}).then(res => {
          if (res.code === '200') {   // 表示操作成功
            this.$message.success('操作成功')
            this.load(1)
          } else {
            this.$message.error(res.msg)  // 弹出错误的信息
          }
        })
      }).catch(() => {
      })
    },
    load(pageNum) {  // 分页查询
      if (pageNum) this.pageNum = pageNum
      // 确保每次加载时都有最新的分类数据
      this.loadCategories()
      
      this.$request.get('/photo/series/admin/list', {
        params: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          name: this.name,
          categoryId: this.categoryId
        }
      }).then(res => {
        this.tableData = res.data?.list
        this.total = res.data?.total
      })
    },
    reset() {
      this.name = null
      this.categoryId = null
      this.load(1)
    },
    handleCurrentChange(pageNum) {
      this.load(pageNum)
    },
  },
  watch: {
    'form.categoryId': {
      handler(newVal) {
        if (newVal) {
          // 根据分类ID查找对应的分类code
          const category = this.categoryOptions.find(item => item.id === newVal);
          if (category) {
            this.form.type = category.code || 'default';
          }
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.avatar-uploader {
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style> 